export const inkindRouteIdKey = 'sb-inkindRouteId';

export const siteTitle = 'Give InKind';

export const stripeTokenLocalStorage = false;

export const warnUnsavedChanges = false;
